export default {
  storeVerificationQuestionList(state, verificationQuestions) {
    state.verificationQuestions = verificationQuestions;
  },

  storeCreatedVerificationQuestion(state,createdVerificationQuestion) {
    state.verificationQuestions << createdVerificationQuestion
  },

  storeVerificationQuestion(state,verificationQuestion) {
    state.verificationQuestion = verificationQuestion
  },
  
  storeUpdatedVerificationQuestion(state,updatedPartner) {
    state.partner = updatedPartner
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/verification_questions/mutations.js